export default "__VITE_ASSET__BV5ZO6e0__"